import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";
import FAQ from "./components/FAQ";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Team from "./components/Team";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Application from "./components/Application";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQ isBanner />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features isBanner />} />
        {/* <Route path="/pricing" element={<Pricing isBanner />} /> */}
        <Route path="/team" element={<Team isBanner />} />
        <Route path="/application" element={<Application isBanner />} />
        <Route path="/contact" element={<Contact isBanner />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
